<template>
<main class="gallery-detail">
    <header class="gallery-detail__header">
      <router-link to="/gallery-overview">← Alle Fotoalben</router-link>
      <p><span></span> Clubnacht</p>
      <h1>{{ gallery.title || 'Fotoalbum' }}</h1>
    </header>

    <section class="gallery-detail__stage">
      <div v-if="!galleryLoaded" class="gallery-detail__loading" aria-label="Bilder werden geladen">
        <div></div>
        <p>Bilder werden geladen</p>
      </div>
      <carousel
        v-else
        ref="carousel"
        class="carousel image__wrapper"
        :perPage="1"
        :paginationEnabled="false"
        :navigationEnabled="true"
      >
          <slide v-for="image in gallery.images" :key="image.imgid || image.id">
              <div v-lazyload class="carousel-slide flex">
                  <div class="skeleton skeleton-loading col-12"></div>
                  <img class="contain image__item mx-auto" :data-url="image.thumbnaillink" :alt="gallery.title">
              </div>
          </slide>
      </carousel>
      <div class="gallery-detail__meta flex align-middle justify-between">
        <p>Bild {{galleryLoaded && $refs.carousel ? ($refs.carousel.currentPage + 1) : '0'}} von {{gallery.images.length}}</p>
        <a :href="whatsappShareHref">Bild teilen <span>↗</span></a>
      </div>
    </section>
</main>
</template>
<script>
import { EventBus } from '../event-bus.js';

import axios from 'axios';
import { apiUrl } from '../api';
export default {
  name: "Gallery",
  data() {
    return {
      session: {},
      gallery: {
          galleryid: '',
          title: '',
          thumbnail: 'avocado.jpg',
          images: []
      },
      galleryLoaded: false
    };
  },
  created() {
    window.scrollTo(0,0);
    EventBus.$on('loginSuccessful', (payload) => {
      this.session = payload.session;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.session = payload.session;

      this.loadGallery();
    });
  },
  mounted(){
    EventBus.$emit('loginCheck', {});
    this.loadGallery();
    console.log('gallery route:')
    console.log(this.$route)
    console.log('gallery params:')
    console.log(this.$route.params)
  },
  computed: {
    activeImg(){
      if(this.galleryLoaded == true && this.$refs.carousel && this.gallery.images.length){
        const { href } = this.$router.resolve(this.gallery.images[this.$refs.carousel.currentPage].id); 
        window.history.pushState({}, null, href);
        console.log('gallery route updated:')
        console.log(this.$route)
        return this.gallery.images[this.$refs.carousel.currentPage].id
      }else{
        return 'not loaded';
      }
    },
    whatsappShareHref() {
      const origin = (typeof window !== 'undefined' && window.location && window.location.origin)
        ? window.location.origin
        : 'https://app.nachtschicht-schortens.de';
      const text = origin + '/#/gallery/' + this.$route.params.galleryid + '/' + this.$route.params.picid;
      return 'whatsapp://send?text=' + encodeURIComponent(text);
    },
  },
  watch: {
    activeImg(newValue){
      console.log('newValue: ' + newValue)
    },
    '$route.params.picid': {
      handler: function(newValue){
        console.log('route param changed')
        console.log(newValue)
              if(newValue !== '0'){
              console.log('picid not 0')
              var pic = this.gallery.images.find(x => x.id === this.$route.params.picid);
              console.log(this.gallery.images.indexOf(pic))
              this.$refs.carousel.currentPage = this.gallery.images.indexOf(pic);
              this.$refs.carousel.offset = this.$refs.carousel.carouselWidth * this.gallery.images.indexOf(pic);
            }
      }
    }
  },
  methods: {
    addHashToLocation(params) {
      // history.pushState(
      //   {},
      //   null,
      //   this.$route.path + '#/gallery/' + this.gallery.galleryid + '/' + encodeURIComponent(params)
      // )
      const { href } = this.$router.resolve(params); window.history.pushState({}, null, href);
    },
    loadGallery(){
        this.gallery.galleryid = this.$route.params.galleryid;
        let that = this;
        console.log('Loading Gallery');
        let url =  apiUrl('/public-api/get/images/json');
        let data = {};
        data.galleries_id = this.$route.params.galleryid;
        console.log(data.galleries_id);
        axios.post(url, data)
        .then(response => {
            console.log(response.data.data);
            that.gallery.images = response.data.data;
            const categoryName = response.data.data[0].category_name || 'Fotoalbum';
            that.gallery.title = categoryName.replace(/^Nachtschicht-Schortens\s*→\s*/, '');
            that.galleryLoaded = true;
            that.$nextTick(() => {
              if(that.$route.params.picid !== '0'){
                var pic = that.gallery.images.find(x => x.id === that.$route.params.picid);
                var index = that.gallery.images.indexOf(pic);
                if (index >= 0 && that.$refs.carousel) {
                  that.$refs.carousel.currentPage = index;
                  that.$refs.carousel.offset = that.$refs.carousel.carouselWidth * index;
                }
              }
            });
            
        })
        .catch(function () {
            //console.log('catch Function of AJAX-Called... userprofileError()');
        });
    }
  }
}
</script>
<style scoped>
.gallery-detail {
  min-height: 100vh;
  padding-bottom: 80px;
  background: #08080a;
}
.gallery-detail__header {
  width: min(calc(100% - 44px), 1120px);
  margin: 0 auto;
  padding: 54px 0 32px;
}
.gallery-detail__header > a {
  display: inline-block;
  margin-bottom: 46px;
  color: rgba(255,255,255,.58);
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
}
.gallery-detail__header > a:hover {
  color: #dcff21;
}
.gallery-detail__header > p,
.gallery-detail__comments-heading > p {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255,255,255,.64);
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .18em;
  text-transform: uppercase;
}
.gallery-detail__header > p span,
.gallery-detail__comments-heading > p span {
  width: 22px;
  height: 3px;
  background: #cc2cce;
}
.gallery-detail__header h1 {
  max-width: 980px;
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: clamp(36px, 6vw, 76px);
  font-weight: 700;
  line-height: .98;
  text-transform: uppercase;
}
.gallery-detail__stage {
  width: min(calc(100% - 44px), 1120px);
  margin: 0 auto;
  border: 1px solid rgba(255,255,255,.12);
  background: #000;
}
.gallery-detail__stage .carousel {
  min-height: 520px;
}
.gallery-detail__stage .carousel-slide {
  min-height: 520px;
  align-items: center;
  justify-content: center;
}
.gallery-detail__stage .carousel-slide img {
  width: auto;
  max-width: 100%;
  max-height: 74vh;
}
.gallery-detail__loading {
  min-height: 520px;
  display: grid;
  place-content: center;
  gap: 18px;
  color: rgba(255,255,255,.5);
  text-align: center;
  background:
    linear-gradient(110deg, transparent 18%, rgba(255,255,255,.055) 35%, transparent 52%) -200% 0 / 200% 100%,
    #121013;
  animation: detailShimmer 1.35s ease-in-out infinite;
}
.gallery-detail__loading div {
  width: 38px;
  height: 38px;
  margin: auto;
  border: 2px solid rgba(255,255,255,.16);
  border-top-color: #cc2cce;
  border-radius: 50%;
  animation: detailSpin .8s linear infinite;
}
.gallery-detail__loading p {
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .12em;
  text-transform: uppercase;
}
@keyframes detailShimmer {
  to { background-position: 200% 0, 0 0; }
}
@keyframes detailSpin {
  to { transform: rotate(360deg); }
}
.gallery-detail__meta {
  min-height: 58px;
  padding: 0 20px;
  border-top: 1px solid rgba(255,255,255,.12);
  color: rgba(255,255,255,.58);
  font-size: 12px;
}
.gallery-detail__meta a {
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.gallery-detail__meta a span {
  margin-left: 8px;
  color: #dcff21;
}
.gallery-detail__comments {
  width: min(calc(100% - 44px), 920px);
  margin: 0 auto;
  padding-top: 80px;
}
.gallery-detail__comments-heading h2 {
  margin-bottom: 28px;
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: clamp(30px, 4vw, 48px);
  font-weight: 700;
  text-transform: uppercase;
}
.gallery-detail__comment-loading {
  padding: 28px 0;
}
.gallery-detail__comment-loading span {
  width: 72%;
  height: 10px;
  margin-top: 10px;
  display: block;
  background: linear-gradient(90deg, #18141c, #2a2433, #18141c);
  background-size: 200% 100%;
  animation: commentShimmer 1.2s linear infinite;
}
.gallery-detail__comment-loading span:last-child {
  width: 42%;
}
@keyframes commentShimmer {
  to { background-position: -200% 0; }
}
.gallery-detail__empty {
  padding: 28px 0;
  color: rgba(255,255,255,.58);
  border-bottom: 1px solid rgba(255,255,255,.12);
}
@media (max-width: 700px) {
  .gallery-detail__header {
    padding-top: 34px;
  }
  .gallery-detail__header > a {
    margin-bottom: 34px;
  }
  .gallery-detail__stage .carousel,
  .gallery-detail__stage .carousel-slide,
  .gallery-detail__loading {
    min-height: 360px;
  }
}
</style>
